// extracted by mini-css-extract-plugin
export default {"page":"notFound_page__DFBtN","page__title":"notFound_page__title__qAOdW"};